import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ShifttypeTypeService } from '@app/core';
import { ShifttypeType } from '@app/shared';

@Injectable({
    providedIn: 'root'
})
export class ShifttypeTypeResolverService {

    constructor(
        private shifttypeTypeService: ShifttypeTypeService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ShifttypeType> {
        const id = route.paramMap.get('id');

        if (id === null) {
            return of(new ShifttypeType());
        }

        return this.shifttypeTypeService.get(+id).pipe(
            map(shifttypeType => {
                if (shifttypeType) {
                    return shifttypeType;
                }
                this.router.navigate(['../shifttype-type-list']);
                return null;
            })
        );
    }
}
